import React from 'react';

const About = () => {
  return (
    <section className="section adavantages-sec bg-light-200">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-5">
                    <div>
                        <div className="section-right-img-two wow fadeInUp" data-wow-delay="1.5">
                            <img src="assets/img/section-img-02.png" alt="img"/>
                            <div className="card review-rate-top border-0 mb-0">
                                <div className="card-body d-flex align-items-center">
                                    <div className="avatar-list-stacked avatar-group-md me-2">
                                        <span className="avatar avatar-rounded">
											<img className="border border-white" src="assets/img/users/user-01.jpg" alt="img"/>
										</span>
                                        <span className="avatar avatar-rounded">
											<img className="border border-white" src="assets/img/users/user-04.jpg" alt="img"/>
										</span>
                                        <span className="avatar avatar-rounded">
											<img className="border border-white" src="assets/img/users/user-06.jpg" alt="img"/>
										</span>
                                        <span className="avatar avatar-rounded">
											<img className="border border-white" src="assets/img/users/user-07.jpg" alt="img"/>
										</span>
                                    </div>
                                    <div>
                                        <div className="d-flex align-items-center fs-12">
                                            <i className="ti ti-star-filled text-warning"></i>
                                            <i className="ti ti-star-filled text-warning"></i>
                                            <i className="ti ti-star-filled text-warning"></i>
                                            <i className="ti ti-star-filled text-warning"></i>
                                            <i className="ti ti-star-filled text-warning me-1"></i>
                                            <p className="fs-14 text-gray-9">5.0</p>
                                        </div>
                                        <p className="fs-14">Hơn 2K đánh giá</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-7">
                    <div>
                        <div className="section-header-six mb-4 wow fadeInUp" data-wow-delay="1.5">
                            <span className="badge badge-soft-primary rounded-pill mb-1">Giới thiệu về chúng tôi</span>
                            <h2 className="mb-2">Cung cấp dịch vụ đặt tour chất lượng cao, giúp chuyến đi của bạn trở nên trọn vẹn & đáng nhớ.</h2>
                            <p>Chúng tôi cung cấp đa dạng các tour du lịch, từ những hành trình khám phá thiên nhiên hoang sơ đến các chuyến du lịch nghỉ dưỡng cao cấp.</p>
                        </div>
                        <div className="row g-2 mb-4">
                            <div className="col-md-6">
                                <span className="d-block mb-2">
									<i className="isax isax-tick-circle5 text-teal fs-24"></i>
								</span>
                                <h6 className="mb-1">Địa điểm thuận tiện</h6>
                                <p>Nhiều điểm đón và trả khách linh hoạt, phù hợp với kế hoạch di chuyển của bạn.</p>
                            </div>
                            <div className="col-md-6">
                                <span className="d-block mb-2">
									<i className="isax isax-tick-circle5 text-orange fs-24"></i>
								</span>
                                <h6 className="mb-1">Dịch vụ tận tâm</h6>
                                <p>Đội ngũ hỗ trợ luôn sẵn sàng giải đáp mọi thắc mắc và nhu cầu của bạn.</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center mb-4">
                            <a href="about-us.html" className="btn btn-dark me-3">Bắt đầu ngay<i className="isax isax-arrow-right-3 ms-2"></i></a>
                            <a data-fancybox="" href="https://youtu.be/NSAOrGb9orM" className="btn btn-white"><i className="isax isax-play-circle5 me-2"></i>Xem video</a>
                        </div>
                        <div className="row g-4">
                            <div className="col-md-4 d-flex">
                                <div className="counter-item card shadow-none flex-fill mb-0">
                                    <div className="card-body">
                                        <h3 className="display-6 text-primary mb-2"><span className="counter text-dark">57</span>+</h3>
                                        <p>Điểm đến trên toàn thế giới</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex">
                                <div className="counter-item card shadow-none flex-fill mb-0">
                                    <div className="card-body">
                                        <h3 className="display-6 text-primary mb-2"><span className="counter text-dark">7098</span>+</h3>
                                        <p>Tour đã được đặt thành công</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 d-flex">
                                <div className="counter-item card shadow-none flex-fill mb-0">
                                    <div className="card-body">
                                        <h3 className="display-6 text-primary mb-2"><span className="counter text-dark">67</span>+</h3>
                                        <p>Khách hàng trên toàn cầu</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default About;
